"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const featureToggle_1 = require("modules/featureToggle");
const afterUploadAlert_1 = require("./afterUploadAlert");
const moduleCoverForm_1 = require("./moduleCoverForm");
const moduleDisplayAlert_1 = require("./moduleDisplayAlert");
var ModuleDisplayTypes;
(function (ModuleDisplayTypes) {
    ModuleDisplayTypes["List"] = "LIST";
    ModuleDisplayTypes["Gallery"] = "GALLERY";
})(ModuleDisplayTypes || (ModuleDisplayTypes = {}));
const ModuleCover = ({ coverImageId, coverImageUrl, moduleDisplayType, createModuleConceptEnabled }) => {
    const isList = moduleDisplayType === ModuleDisplayTypes.List;
    const shouldRenderAfterUploadAlert = coverImageId && isList;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_mb-8", children: [isList && !createModuleConceptEnabled && (0, jsx_runtime_1.jsx)(moduleDisplayAlert_1.ModuleDisplayAlert, {}), (0, jsx_runtime_1.jsx)(moduleCoverForm_1.ModuleCoverForm, { coverImageUrl: coverImageUrl }), shouldRenderAfterUploadAlert && (0, jsx_runtime_1.jsx)(afterUploadAlert_1.AfterUploadAlert, {})] }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)((stores) => ({
    moduleDisplayType: stores.ModuleEditorStore.moduleDisplayType,
    coverImageId: stores.ModuleEditorStore.coverImageId,
    coverImageUrl: stores.ModuleEditorStore.coverImageUrl,
    createModuleConceptEnabled: stores.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.CreateModuleConcept)
})))(ModuleCover);
